import React from 'react'
import { FaEnvelope } from "react-icons/fa";
import { IoMdSettings,  IoIosNotifications } from "react-icons/io";
import { IoNotifications } from "react-icons/io5";

function Welcome() {
  return (
    <div className="content-header" style={{backgroundColor:'#fff',height:126}}>
          <div className="container-fluid" style={{marginTop:30}}>
            <div className="row mb-2" >              
              <div className="col-sm-6">
                <h1 className="m-0" style={{fontFamily:"Arial",color:"#111827",fontSize:34,fontWeight:'bold'}}>Welcome back, Vikas Panchal!</h1>
                <p style={{color:"#6B7280"}}> <IoNotifications style={{display:"inline-block"}}/>You have 2 new messages and 15 new tasks</p>
              </div>
              {/* /.col */}
              <div className="col-sm-6" >
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item" style={{display:'flex', flexDirection:"row",gap:10}}>
                    <button style={{width:124, height:40, color:"#fff", backgroundColor:"rgb(30, 41, 59)",fontWeight:700,borderRadius:50, display:'flex',justifyContent:'center',alignItems:"center",gap:4}}><FaEnvelope /> Messages</button> 
                    <button style={{width:124, height:40, color:"#fff", backgroundColor:"rgb(79, 70, 229)",fontWeight:700,borderRadius:50,display:'flex',justifyContent:'center',alignItems:"center",gap:4}}><IoMdSettings />Settings</button>
                  </li>
                </ol>
              </div>
              {/* /.col */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </div>
  )
}

export default Welcome
